export default function UserProjects() {
    return (
        <div className='p-6 shadow-sm shadow-sub-title/15 rounded-md'>
            <h5 className='text-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-xl mb-8'>
                آثار و پروژه ها :
            </h5>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/1.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/2.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/6.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/10.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/12.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
                <div>
                    <div className='w-full rounded-md overflow-hidden'>
                        <img className='w-full h-full object-cover' src="/images/blogs/11.jpg" alt=""/>
                    </div>
                    <div className='pt-4'>
                        <h6>
                            <a className='text-sub-title font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-lg transition-colors duration-500 hover:text-primary' href="#">
                                ماکت آیفون
                            </a>
                        </h6>
                        <span className='font-IranSansFaNum-Bold dark:font-IranSansDn-Bold text-md'>
                            نام تجاری
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}